import { Button } from "primereact/button";

const AIEduButton = (props) => {
    return (
        <>
            <Button {...props} />
        </>
    );
};

export default AIEduButton;
